import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'professionalIdentificationStep',
  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
    }),
    ...mapGetters({
      isScheduledAdmission: 'global/isScheduledAdmission',
      backOfficeDone: 'backOfficeDone',
      getUploadedMedicalOrders: 'getUploadedMedicalOrders',
    }),
    paymentPrivate() {
      return this.currentAdmission.payments[0].clientId === '44';
    },
    admissionOriginNotEnabled() {
      return (
        this.currentAdmission.source.origin !== 'CDC' &&
        this.currentAdmission.source.origin !== 'NAC'
      );
    },
    identifiedProfessional() {
      return this.currentAdmission.medicalOrders[0].mdmIdRequestingDoctor;
    },
    checkinD0() {
      const date = new Date().toLocaleDateString();
      const dateAdmission = moment(this.currentAdmission.admissionDate).format('DD/MM/YYYY');
      return date === dateAdmission;
    },
    uploadMedicalOrders() {
      return this.getUploadedMedicalOrders.length !== 1;
    },
    admissionUrlMedicalOrders() {
      return !!this.currentAdmission.urlMedicalOrders;
    },
  },
  methods: {
    ...mapActions(['isElegibleProfessionalStep']),

    enableProfessionalStep() {
      const notEnableSteps =
        !this.isScheduledAdmission ||
        this.backOfficeDone ||
        this.paymentPrivate ||
        this.admissionOriginNotEnabled ||
        this.checkinD0 ||
        this.admissionUrlMedicalOrders ||
        this.identifiedProfessional ||
        this.uploadMedicalOrders;

      if (notEnableSteps) {
        return this.isElegibleProfessionalStep(false);
      }

      return this.isElegibleProfessionalStep(true);
    },
  },
};
